import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useRef } from 'react';
import { TaktIdProvider, createStormTaktId, useIsMobile, Flex, Sheet, Popover } from '@amzn/storm-ui';
import { L as LabelText, T as TextButton, a as TextButtonIcon } from './TextButtonPopoverAttribute.styles-CnhTIgAq.js';
import { g as getTranslationComponent } from '../../../i18n/PageHeaderTranslation/index-D-JlEl92.js';
import { I as IntlProvider } from '../../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DmRs8GLp-yq9BpgTU.js';
import { u as useIntl } from '../../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';
import { b as angleDown } from '../../../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-B8hoEVqo.js';

const LocalizedTextButtonPopoverAttribute = ({
  id,
  prefixLabel,
  content,
  popoverContent,
  popoverPosition = 'top',
  withCloseButton = false,
  taktId,
  taktValue,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const textButtonRef = useRef(null);
  const handleToggle = () => setIsOpen(!isOpen);
  const handleClose = () => setIsOpen(false);
  return /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center",
    id: id
  }, /*#__PURE__*/React__default.createElement(LabelText, null, prefixLabel, ":"), isMobile ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Sheet, {
    closeButton: {
      type: 'icon',
      label: formatMessage({
        id: 'close-label'
      })
    },
    isOpen: isOpen,
    onClose: handleClose,
    side: "bottom",
    toggleEl: textButtonRef
  }, popoverContent), /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
    onClick: handleToggle,
    buttonRef: textButtonRef
  }), content, /*#__PURE__*/React__default.createElement(TextButtonIcon, {
    type: angleDown
  }))) : /*#__PURE__*/React__default.createElement(Popover, {
    isOpen: isOpen,
    trigger: /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
      onClick: handleToggle
    }), content, /*#__PURE__*/React__default.createElement(TextButtonIcon, {
      type: angleDown
    })),
    withCloseButton: withCloseButton,
    onCloseButtonClick: handleClose,
    position: popoverPosition
  }, popoverContent));
};
const TextButtonPopoverAttribute = ({
  locale = 'en-US',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('page-header-text-button-popover-attribute')
}, /*#__PURE__*/React__default.createElement(IntlProvider, {
  resetKey: locale,
  translations: getTranslationComponent(locale)
}, /*#__PURE__*/React__default.createElement(LocalizedTextButtonPopoverAttribute, rest)));

export { TextButtonPopoverAttribute as T };
//# sourceMappingURL=TextButtonPopoverAttribute-BJbxxueo.js.map
